module.exports = __webpack_public_path__ + "static/prfai-a75581baab0715f2ec63c2a29a2400d2.png";